import React, { useEffect } from "react";
import MdaePopup, {
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
  MdaePopupTitle,
} from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import {
  SET_BELL_CURVE_REPORT_PARAMETER_VALUES,
  SET_GRID_HEADER_VALUES,
  SET_EM_PROVIDER_LIST,
  SET_WIDGET_INSTANCE,
  TOGGLE_BELL_CURVE_REPORT_PARAMETER_POPUP,
  TOGGLE_BELL_CURVE_REPORT_WARNING_POPUP,
} from "./reducers/bell-curve-report-parameter-reducer";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid } from "devextreme-react";
import { Column, MasterDetail } from "devextreme-react/data-grid";
import $ from "jquery";
import DetailTemplate from "./detail-template";
import { callOperation, actions } from "async-ops";
import { GET_EM_CATEGORY_LIST } from "./services/get-em-category-list";
import { GET_EM_DOS_LIST } from "./services/get-em-dos-list";
import "./index.scss";
import { GET_EM_UTILIZATION_LIST } from "./services/get-em-utilization-list";
import { GET_EM_PROVIDER_LIST } from "./services/get-em-provider-list";
import { GENERATE_EM_BELL_CURVE_REPORT } from "./services/generate-em-bell-curve-report";
import {
  SHOW_LOADER,
  HIDE_LOADER,
  TOGGLE_NOTIFY_POPUP,
} from "../../common_components/mdae-common-reducer";
import { NOTIFY_POPUP_TYPES } from "../common_widgets/notify-popup";
import BellCurveReportWarningPopup from "./bell-curve-report-warning-popup";

const BellCurveReportParameter: React.FC<any> = (props) => {
  var mainGridDataSource = useSelector(
    (state: any) => state.bellCurveReportParameterReducer.mainGrid
  );
  var bellCurveReportOneYearMonthList = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.bellCurveReportOneYearMonthList
  );
  var bellCurveReportParameterEmDOSSelectedItems = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer
        .bellCurveReportParameterEmDOSSelectedItems
  );
  var bellCurveReportParameterEmDOSList = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.bellCurveReportParameterEmDOSList
  );
  var bellCurveReportParameterWidgetInstances = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer
        .bellCurveReportParameterWidgetInstances
  );
  var bellCurveReportParameterSeriesValues = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.bellCurveReportParameterSeriesValues
  );
  var bellCurveReportParameterValues = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer.bellCurveReportParameterValues
  );
  var bellCurveReportParameterSeriesCheckboxText = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer
        .bellCurveReportParameterSeriesCheckboxText
  );
  var bellCurveReportParameterSeriesCheckboxDisabled = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer
        .bellCurveReportParameterDisabledCheckbox
  );
  var bellCurveReportParameterSeriesCheckboxValue = useSelector(
    (state: any) =>
      state.bellCurveReportParameterReducer
        .bellCurveReportParameterSeriesCheckboxValue
  );
  var normativeSelectedItem = useSelector(
    (state: any) => state.bellCurveReportParameterReducer.normativeSelectedItem
  );
  var isDataSourceLoaded = useSelector(
    (state: any) => state.bellCurveReportParameterReducer.isDataSourceLoaded
  );
  var defaultCategory = useSelector(
    (state: any) => state.bellCurveReportParameterReducer.defaultCategory
  );
  const bellCurveReportParameterValue = {
    dosList: [],
    categoryList: [defaultCategory],
    selectedTargetType: "",
    selectedTargetProviderValue: null,
    selectedTargetProviderGroupValue: null,
    isIncludeLowVolumeProviders: false,
    isNormativeSeriesSelected: false,
    normativeSeriesValues: [],
    normativeSelectedSeriesValues: [],
    isProviderGroupSeriesSelected: false,
    providerGroupSeriesValues: [],
    isProviderClassificationSeriesSelected: false,
    providerClassificationSeriesSelectedValues: [],
    isProviderSpecializationSeriesSelected: false,
    providerSpecializationSeriesSelectedValues: [],
    exportFormatForLongRunningReports: "pdf"
  };
  const dispatch = useDispatch();

  const getDaysInMonth = (year, month) => {
    return new Date(year, month, 0).getDate();
  };
  const addMonths = (input, months) => {
    const date = new Date(input);
    date.setDate(1);
    date.setMonth(date.getMonth() + months);
    date.setDate(
      Math.min(
        input.getDate(),
        getDaysInMonth(date.getFullYear(), date.getMonth() + 1)
      )
    );
    return date;
  };
  const getFirstDateOfLastMonth = () => {
    var today = new Date();
    var month = today.getMonth();
    return new Date(new Date(today.setMonth(month - 1)).setDate(1));
  };

  const setDefaultValues = (
    bellCurveReportParameterEmDOSList,
    bellCurveReportParameterWidgetInstances
  ) => {
    bellCurveReportParameterEmDOSSelectedItems = [];
    var sixMonthBackDate = addMonths(getFirstDateOfLastMonth(), -6);
    for (let i = 0; i < bellCurveReportParameterEmDOSList.length; i++) {
      for (
        let j = 0;
        j < bellCurveReportParameterEmDOSList[i].items.length;
        j++
      ) {
        for (
          let k = 0;
          k < bellCurveReportParameterEmDOSList[i].items[j].items.length;
          k++
        ) {
          var m = bellCurveReportParameterEmDOSList[i].items[j].items[k];
          var mDate = new Date(m.id);
          if (mDate >= sixMonthBackDate && mDate <= getFirstDateOfLastMonth()) {
            bellCurveReportParameterEmDOSList[i].items[j].items[
              k
            ].selected = true;
            bellCurveReportParameterEmDOSSelectedItems.push(
              bellCurveReportParameterEmDOSList[i].items[j].items[k]
            );
            if (bellCurveReportParameterWidgetInstances.dosTreeView)
              bellCurveReportParameterWidgetInstances.dosTreeView.selectItem(
                bellCurveReportParameterEmDOSList[i].items[j].items[k].id
              );
          } else {
            bellCurveReportParameterEmDOSList[i].items[j].items[
              k
            ].selected = false;
            bellCurveReportParameterEmDOSList[i].items[j].items[
              k
            ].isExpanded = false;
            bellCurveReportParameterEmDOSList[i].items[j].selected = false;
            bellCurveReportParameterEmDOSList[i].items[j].isExpanded = false;
            bellCurveReportParameterEmDOSList[i].selected = false;
            bellCurveReportParameterEmDOSList[i].isExpanded = false;
          }
        }
      }
    }
    dispatch({
      type: SET_GRID_HEADER_VALUES,
      data: {
        rowIndex: 0,
        bellCurveReportParameterEmDOSSelectedItems: bellCurveReportParameterEmDOSSelectedItems,
        bellCurveReportParameterEmDOSList: bellCurveReportParameterEmDOSList,
      },
    });
  };

  const getBellCurveReportPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleBellCurveReportPopup(false);
        }}
      >
        Bell Curve Report Parameters
      </MdaePopupTitle>
    );
  };
  const toggleBellCurveReportPopup = (isVisible) => {
    dispatch({
      type: TOGGLE_BELL_CURVE_REPORT_PARAMETER_POPUP,
      data: {
        isbellCurveReportParameterPopupVisible: isVisible,
      },
    });
  };
  const onBellCurveReportParameterDataGridInitialized = (e) => {
    var bellCurveReportParameterMainDataGridInstance = e.component;
    dispatch({
      type: SET_WIDGET_INSTANCE,
      data: {
        bellCurveReportParameterWidgetInstances: {
          mainDataGrid: bellCurveReportParameterMainDataGridInstance,
        },
      },
    });
  };
  const renderfieldNameItem = (itemData) => {
    return <div className="mdae-data-field-label">{itemData.text}</div>;
  };
  const renderSelectedValueItem = (itemData) => {
    return (
      <div
        className="mdae-data-field-content bell-curve-report-parameter-selected-value"
        title={itemData.text}
      >
        {itemData.text}
      </div>
    );
  };
  const onRowPrepared = (e) => {
    $(e.component.getRowElement()).addClass(
      "bell-curve-report-master-grid-table-row"
    );
  };

  const toggleBellCurveReportWarningPopupVisible = (isVisible) => {
    dispatch({
      type: TOGGLE_BELL_CURVE_REPORT_WARNING_POPUP,
      data: {
        isBellCurveReportWarningPopupVisible: isVisible
      },
    });
    if (!isVisible) {
      dispatch({
        type: TOGGLE_BELL_CURVE_REPORT_PARAMETER_POPUP,
        data: {
          isbellCurveReportParameterPopupVisible: false,
        },
      });
    }
  };

  const onBellCurveReportParamPopupShown = (e) => {
    if (!isDataSourceLoaded) {
      dispatch(actions.asyncOperationStart(GET_EM_CATEGORY_LIST, {}));
      dispatch(actions.asyncOperationStart(GET_EM_UTILIZATION_LIST, {}));
      dispatch(actions.asyncOperationStart(GET_EM_DOS_LIST, {}));
      dispatch({ type: SHOW_LOADER });
      callOperation(GET_EM_PROVIDER_LIST, bellCurveReportOneYearMonthList).then(
        function (response) {
          dispatch({
            type: SET_EM_PROVIDER_LIST,
            data: { response, isDataSourceLoaded: true },
          });
        }
      );
      setNormativeDataSourceValueChangeEffectes();
      setDefaultValues(
        bellCurveReportParameterEmDOSList,
        bellCurveReportParameterWidgetInstances
      );
      collpaseMainGridRows(
        mainGridDataSource,
        bellCurveReportParameterWidgetInstances.mainDataGrid
      );
      setTimeout(function () {
        dispatch({
          type: SET_GRID_HEADER_VALUES,
          data: {
            rowIndex: 1,
          },
        });
      }, 100);
      isDataSourceLoaded = true;
      dispatch({ type: HIDE_LOADER });
    } else {
      dispatch({
        type: SET_BELL_CURVE_REPORT_PARAMETER_VALUES,
        data: {
          bellCurveReportParameterValues: bellCurveReportParameterValue,
        },
      });
      setDefaultValues(
        bellCurveReportParameterEmDOSList,
        bellCurveReportParameterWidgetInstances
      );
      dispatch({
        type: SET_GRID_HEADER_VALUES,
        data: {
          rowIndex: 1,
        },
      });
      collpaseMainGridRows(
        mainGridDataSource,
        bellCurveReportParameterWidgetInstances.mainDataGrid
      );
    }
  };

  const runReportClick = () => {
    bellCurveReportParameterValues.dosList = getSelectedDosItems();
    bellCurveReportParameterValues.providerGroupSeriesValues =
      bellCurveReportParameterSeriesValues.providerGroup;
    bellCurveReportParameterValues.providerClassificationSeriesSelectedValues =
      bellCurveReportParameterSeriesValues.providerClassification;
    bellCurveReportParameterValues.providerSpecializationSeriesSelectedValues =
      bellCurveReportParameterSeriesValues.providerSpecialization;
    bellCurveReportParameterValues.normativeSelectedSeriesValues.forEach(
      function (item) {
        bellCurveReportParameterValues.normativeSeriesValues.push(item.key);
      }
    );

    var errorMessage = "";
    if (
      (!bellCurveReportParameterValues.selectedTargetProviderValue ||
        !bellCurveReportParameterValues.selectedTargetProviderValue
          .providerNpi) &&
      (!bellCurveReportParameterValues.selectedTargetProviderGroupValue ||
        !bellCurveReportParameterValues.selectedTargetProviderGroupValue
          .providerGroupId)
    ) {
      errorMessage =
        "You must select a target provider or Rendering Provider Group to generate the report.";
    }

    if (bellCurveReportParameterValues.categoryList.length <= 0) {
      errorMessage =
        "You must select at least one E&M Category to generate the report.";
    }

    if (bellCurveReportParameterValues.dosList.length <= 0) {
      errorMessage = "You must select a DOS range to generate the report.";
    }
    if (errorMessage) {
      dispatch({
        type: TOGGLE_NOTIFY_POPUP,
        data: {
          height: 240,
          width: 410,
          visible: true,
          contentHtml: () => {
            return errorMessage;
          },
          notifyPopupType: NOTIFY_POPUP_TYPES.WARNING,
          closeButtonText: "OK",
        },
      });
      return false;
    }
    dispatch({ type: SHOW_LOADER });
    callOperation(
      GENERATE_EM_BELL_CURVE_REPORT,
      bellCurveReportParameterValues
    ).then(function (response) {
      if (response !== null) {
        dispatch({ type: HIDE_LOADER });
        if (response.status == "TimeOut") {
          toggleBellCurveReportWarningPopupVisible(true);
        } else if (response.status == "Completed") {
          var dosStart = null;
          var dosEnd = null;
          if (
            bellCurveReportParameterValues.dosList != null &&
            bellCurveReportParameterValues.dosList.length > 0
          ) {
            dosStart = bellCurveReportParameterValues.dosList[0].id;
            dosEnd =
              bellCurveReportParameterValues.dosList[
                bellCurveReportParameterValues.dosList.length - 1
              ].id;
          }
          window.open(
            "/EMBellCurveReport/StandardReport?DOSStart=" +
            dosStart +
            "&DOSEnd=" +
            dosEnd,
            "_blank"
          );
        } else {
          errorMessage =
            "The selected parameters returned no data. Please change your selections.";
          dispatch({
            type: TOGGLE_NOTIFY_POPUP,
            data: {
              height: 240,
              width: 400,
              visible: true,
              contentHtml: () => {
                return errorMessage;
              },
              notifyPopupType: NOTIFY_POPUP_TYPES.WARNING,
              closeButtonText: "OK",
            },
          });
        }
      }
    });
  };

  function getSelectedDosItems() {
    bellCurveReportParameterEmDOSSelectedItems = [];
    for (let i = 0; i < bellCurveReportParameterEmDOSList.length; i++) {
      for (
        let j = 0;
        j < bellCurveReportParameterEmDOSList[i].items.length;
        j++
      ) {
        for (
          let k = 0;
          k < bellCurveReportParameterEmDOSList[i].items[j].items.length;
          k++
        ) {
          if (bellCurveReportParameterEmDOSList[i].items[j].items[k].selected) {
            bellCurveReportParameterEmDOSSelectedItems.push(
              bellCurveReportParameterEmDOSList[i].items[j].items[k]
            );
          }
        }
      }
    }
    return bellCurveReportParameterEmDOSSelectedItems;
  }

  const collpaseMainGridRows = (mainGridDataSource, mainDataGridInstance) => {
    for (let i = 0; i < mainGridDataSource.length; i++) {
      var dataGridFieldName = mainGridDataSource[i].fieldName;
      if (
        dataGridFieldName &&
        dataGridFieldName.toLowerCase() == "e&m categories:"
      ) {
        mainDataGridInstance.expandRow(mainGridDataSource[i].fieldName);
        mainDataGridInstance.collapseRow(mainGridDataSource[i].fieldName);
      }
      if (
        dataGridFieldName &&
        dataGridFieldName.toLowerCase() == "define target:"
      ) {
        mainDataGridInstance.expandRow(mainGridDataSource[i].fieldName);
      } else {
        mainDataGridInstance.collapseRow(mainGridDataSource[i].fieldName);
      }
      if (
        dataGridFieldName &&
        dataGridFieldName.toLowerCase() == "additional report options:"
      ) {
        mainDataGridInstance.expandRow(mainGridDataSource[i].fieldName);
        mainDataGridInstance.collapseRow(mainGridDataSource[i].fieldName);
      }
      if (
        dataGridFieldName &&
        dataGridFieldName.toLowerCase() == "dos range:"
      ) {
        mainDataGridInstance.expandRow(mainGridDataSource[i].fieldName);
        mainDataGridInstance.collapseRow(mainGridDataSource[i].fieldName);
      }
    }
  };

  function setNormativeDataSourceValueChangeEffectes() {
    var selectedItems = normativeSelectedItem;
    if (selectedItems && selectedItems.length) {
      var checkboxText = "";
      for (let i = 0; i < selectedItems.length; i++) {
        checkboxText = checkboxText + selectedItems[i].dataSourceName + ",";
      }
      checkboxText = checkboxText.slice(0, checkboxText.length - 1);
      bellCurveReportParameterSeriesCheckboxValue.bellCurveReportParameterIsProviderGroupSeriesCheckboxValue = true;
      bellCurveReportParameterSeriesCheckboxDisabled.bellCurveReportParameterIsNormativeSeriesCheckboxDisable = false;
      bellCurveReportParameterSeriesCheckboxText.bellCurveReportParameterIsNormativeSeriesCheckboxText =
        "Normative (" + checkboxText + ")";
    }
  }

  return (
    <div>
      <BellCurveReportWarningPopup
        toggleBellCurveReportWarningPopupVisible={toggleBellCurveReportWarningPopupVisible}
      />
      <MdaePopup
        deferRendering={false}
        height={590}
        maxWidth={850}
        id={"pnlBellCurveReportPopup"}
        mdaeTitleRender={getBellCurveReportPopupTitle}
        onShown={onBellCurveReportParamPopupShown}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_BELL_CURVE_REPORT_PARAMETER_POPUP,
            reducerName: "bellCurveReportParameterReducer",
            widgetOptionBindings: {
              visible: "isbellCurveReportParameterPopupVisible",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <DataGrid
                  id={"bellCurveReportDatagrid"}
                  dataSource={mainGridDataSource}
                  keyExpr={"fieldName"}
                  showColumnHeaders={false}
                  showColumnLines={false}
                  showRowLines={false}
                  showBorders={false}
                  onRowPrepared={onRowPrepared}
                  onContentReady={(e) => {
                    $(e.component.element())
                      .find("table")
                      .addClass("bell-curve-report-master-grid-table");
                  }}
                  onInitialized={onBellCurveReportParameterDataGridInitialized}
                >
                  <Column
                    dataField="fieldName"
                    width="40%"
                    cellRender={renderfieldNameItem}
                  />
                  <Column
                    dataField="selectedValue"
                    width="60%"
                    cellRender={renderSelectedValueItem}
                  />
                  <MasterDetail enabled={true} component={DetailTemplate} />
                </DataGrid>
              </MdaePopupContent>
            </div>
          );
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"btnCancelBellCurveReport"}
                  role={"secondary"}
                  onClick={() => {
                    toggleBellCurveReportPopup(false);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"btnRunBellCurveReport"}
                  onClick={() => {
                    runReportClick();
                  }}
                  role={"primary"}
                >
                  Run Report
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
      <DetailTemplate></DetailTemplate>
    </div>
  );
};
export default BellCurveReportParameter;
